import { ALLOWED_KEYS } from "@core/constants";
import { StorageManager } from "./storage.manager";

/**
 * DataLayerManager for implement datalayer on our apps to be able to track more efficiently visitor with GA
 * @class DataLayerManager
 */
export class DataLayerManager {
  /**
   * Get specific URL parameter value
   * @static
   * @param {String} param - parameter name to extract
   * @returns {String|undefined}
   */
  static getUrlParam = (param) => {
    const url = window.location.href;
    const [basePart, hashPart] = url.split("#");

    const extractParam = (part) => {
      const match = part.match(new RegExp(`${param}=([^&%]+)`));
      return match ? match[1] : undefined;
    };

    let paramValue = extractParam(basePart);

    if (!paramValue && hashPart) {
      paramValue = extractParam(hashPart);
    }

    return paramValue;
  };
  /**
   * Set data into the datalayer object
   * @static
   * @param {Object} params - data parameters to overload parameters into data object
   * @param {String} site - the current page_site name
   * @param {String} user - the current user_type
   * @returns {Object}
   */
  static setData(params, site, user) {
    setTimeout(() => {
      const partner = this.setUrlParamCampaign();
      const data = {
        page_site: site,
        page_type: "espace_connecte",
        page_name: document.title,
        page_url: window.location.href.split("?")[0],
        language: "FR",
        user_connect: "yes",
        user_type: user,
        partner,
      };

      if (params) {
        Object.keys(params).forEach((key) => {
          if (ALLOWED_KEYS.includes(key) && params[key] !== "") {
            data[key] = params[key];
          }
        });
      }

      this.deleteData();

      return window.dataLayer.push(data);
    }, 400);
  }

  /**
   * Delete the previous object in datalayer
   * @static
   */
  static deleteData = () => {
    const key = "page_site";
    const index = window.dataLayer.findIndex((obj) => Object.prototype.hasOwnProperty.call(obj, key));

    if (index !== -1) {
      window.dataLayer.splice(index, 1);
    }
  };

  static handleDataLayer = (type) => {
    return async (to, from, next) => {
      this.setData(false, type, StorageManager.getUserInfo(type));
      next();
    };
  };

  /**
   * Get the value of utm_campaign or xtra_campaign
   * @static
   */
  static getUrlParamCampaign = () => {
    const url = window.location.href;

    // Extract the part before and after the #
    const [basePart, hashPart] = url.split("#");

    // Variable to store the campaign value
    let campaignValue;

    // Function to extract campaign parameter from a part of the URL
    const extractCampaign = (part) => {
      // Try to find xtra_campaign first
      let match = part.match(/xtra_campaign=([^&]+)/);

      // If not found, try to find utm_campaign
      if (!match) {
        match = part.match(/utm_campaign=([^&]+)/);
      }

      return match ? match[1] : undefined;
    };

    // Check if there is a campaign param before the #
    campaignValue = extractCampaign(basePart);

    if (campaignValue) {
      // If there is a campaign param before the #, only take the value before any additional #
      const endIndex = campaignValue.indexOf("#");
      if (endIndex !== -1) {
        campaignValue = campaignValue.substring(0, endIndex);
      }
    } else if (hashPart) {
      // If there is no campaign param before the #, check after the #
      campaignValue = extractCampaign(hashPart);
    }

    return campaignValue;
  };

  /**
   * update history state on datalayer
   * @static
   */

  static updateHistoryState(newData) {
    const currentState = history.state || {};
    const newState = { ...currentState, ...newData };

    history.replaceState(newState, "", window.location.href);

    window.dataLayer.push({
      event: "newHistoryStateUpdated",
      newHistoryState: newState,
    });
  }

  /**
   * Set the value of the utm_campaign
   * @static
   */

  static setUrlParamCampaign = () => {
    const utmCampaign = this.getUrlParamCampaign();
    const partner = utmCampaign || undefined;
    return partner;
  };
}
